import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { BCol, BRow } from "bootstrap-vue";
import Heading from "@/components/Common/Heading.vue";
import { faInbox } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import NotificationActions from "@/components/Notifications/NotificationActions.vue";
import { useMarkdown } from "@/composables/markdown";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MessageNotification',
    props: {
        notification: null
    },
    setup(__props) {
        const props = __props;
        library.add(faInbox);
        const { renderMarkdown } = useMarkdown({ openLinksInNewPage: true });
        const notificationVariant = computed(() => {
            switch (props.notification.variant) {
                case "urgent":
                    return "danger";
                default:
                    return props.notification.variant;
            }
        });
        return { __sfc: true, renderMarkdown, props, notificationVariant, BCol, BRow, Heading, FontAwesomeIcon, NotificationActions };
    }
});
